import { adGdprSignal } from './consent';

/**
 * Ad tags stored in config/ads.ts and in the CMS are copied straight from the
 * Adventive tag generator, so they carry macros meant for a publisher's ad
 * server (Google Ad Manager and similar). On adventive.com nothing fills them,
 * so:
 *   - `${GDPR}` / `${GDPR_CONSENT_1268}` are replaced with the visitor's real
 *     consent signal from Zaraz (see lib/consent.ts), and
 *   - GAM-only macros are dropped or given a sensible value.
 */

function stripGamMacros(url: string): string {
  return url
    .replace(/cb=(\[RANDOM_NUMBER\]|%%CACHEBUSTER%%)/g, () => `cb=${Math.floor(Math.random() * 1e9)}`)
    .replace(/click=(\[CLICK_TRACKER_ENC\]|%%CLICK_URL_ESC%%|%%CLICK_URL_UNESC%%)/g, 'click=')
    .replace(/fb_url=%%FRAME_BREAK_URL%%/g, 'fb_url=')
    .replace(/ref=%%SITE%%/g, 'ref=')
    // %eaid! %ebuy! %eadv! %ecid! … : drop the whole parameter
    .replace(/&[a-z_]+=%[a-z]+!/g, '');
}

/** Replace the GDPR macros in one tag URL with the given signal (default: this visitor's). */
export function resolveAdUrl(rawUrl: string, signal: string = adGdprSignal()): string {
  let url = stripGamMacros(rawUrl);
  if (/gdpr=[^&]*&gdpr_consent=[^&]*/.test(url)) {
    url = url.replace(/gdpr=[^&]*&gdpr_consent=[^&]*/, signal);
  } else if (/(^|[?&])gdpr=[^&]*/.test(url)) {
    url = url.replace(/gdpr=[^&]*/, signal);
  } else {
    url += (url.includes('?') ? '&' : '?') + signal;
  }
  return url;
}

/** Same substitution applied to a whole tag snippet (HTML containing <script src="https://ads.adventive.com/ad?…">). */
export function resolveAdTagHtml(rawHtml: string, signal: string = adGdprSignal()): string {
  return rawHtml.replace(/https?:\/\/ads\.adventive\.com\/ad\?[^"'\s<>]*/g, (m) => resolveAdUrl(m, signal));
}
